import { useTheme } from '@emotion/react';
import { Box, Button, Dialog, Stack, TablePagination } from '@mui/material';
import { CancelToken } from 'apisauce';
import React from 'react';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import appapi from '../../../../api/apiClient';
import { useEffect } from 'react';
import PageHeader from '../../../../components/PageHeader';
import AddShip from '../../../../assets/images/addShip.svg';
import Datatable from '../../../../components/DataTable';
import TablePaginationActions from '../../../../components/TablePaginationActions';
import FleetDetailsTabPanel from './FleetDetailsTabPanel';
import AddShipTabPanel from './AddShipTabPanel';
import { dialogButtonCancel } from '../../../../utils/commonStyle';
import ConfirmArchiveDialog from '../../../../components/ConfirmArchiveDialog';
import { useTranslation } from 'react-i18next';

const sx = {
  '& .MuiDialog-container': {
    alignItems: 'center',
    WebkitAlignItems: 'center',
    WebkitBoxAlign: 'center',
  },
  '& .MuiPaper-root': {
    width: '100%',
    margin: '8px',
    borderRadius: '4px',
    // maxWidth: '736px',
    height: '100%',
    maxWidth: '100%',
    maxHeight: '90%',
  },
};

export default function ArchiveFleetList({ modelOpen, onModelHandleClose }) {
  const columns = [
    {
      id: 0,
      header: '#',
      accessor: 'Sno',
      width: '5%',
      default: true,
      columnEditable: false,
      activeColumn: true,
    },
    {
      id: 1,
      header: 'Ship name',
      accessor: 'shipName',
      width: '25%',
      default: true,
      columnEditable: false,
      activeColumn: true,
      filter: {
        search: false,
        filterType: 'RadioButton',
        typeFilter: true,
        filterList: [],
      },
    },
    {
      id: 2,
      header: 'Ship type',
      accessor: 'shipType',
      width: '20%',
      capitalize: true,
      default: true,
      columnEditable: true,
      activeColumn: true,
      filter: {
        search: false,
        filterType: 'RadioButton',
        typeFilter: true,
        filterList: [],
      },
    },
    {
      id: 3,
      header: 'IMO number',
      accessor: 'imoNumber',
      width: '20%',
      default: true,
      columnEditable: true,
      activeColumn: true,
      filter: {
        search: false,
        filterType: 'RadioButton',
        typeFilter: true,
        filterList: [],
      },
    },
    {
      id: 4,
      header: 'Owner',
      accessor: 'owner',
      width: '25%',
      default: true,
      columnEditable: true,
      activeColumn: true,
      filter: {
        search: false,
        filterType: 'RadioButton',
        typeFilter: true,
        filterList: [],
      },
    },
  ];

  const theme = useTheme();
  const [search, setSearch] = useState(null);
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [shipsList, setShipsList] = useState([]);
  const [filter1, setFilter1] = useState([]);
  const [openAddEditShip, setAddEditShipOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [customerManagementColumn, setCustomerManagementColumn] = useState(columns);
  const [reload, setReload] = useState(false);

  const [selectedHistory, setSelectedHistory] = useState(null);
  const [openArchiveDialog, setOpenArchiveDialog] = useState(false);
  const [openArchiveList, setOpenArchiveList] = useState(false);

  const [selectedData, setSelectedData] = useState(null);
  const [list, setList] = useState([])

  const {t} = useTranslation()

  const [payload, setPayload] = useState({
    page: 1,
    limit: 10,
    filter: null,
    totalLength: 0,
    paginationPage: 0,
    status: 0,
    field: '_id',
    sortOrder: 'desc',
  });

  const { userId, companyDetails, user } = useSelector((state) => state.auth);

  let source = CancelToken.source();
  const text = theme.palette.primary.text;

  const handleChangePage = (event, newPage) => {
    setPayload((prevState) => ({ ...prevState, page: newPage + 1, paginationPage: newPage, filter: payload.filter }));
  };

  const handleChangeRowsPerPage = (event) => {
    setPayload((prev) => ({ ...prev, limt: parseInt(event.target.value, 10), paginationPage: 1, page: 1, filter: payload.filter }));
  };

  //search filter
  const handleSearchEmit = (search) => {
    setPayload((prevState) => ({ ...prevState, limt: 10, paginationPage: 0, page: 1, filter: search }));
  };

  const handleToggleDrawer = () => {
    setIsDrawerOpen(!isDrawerOpen);
  };

  const handleOnChangeCheckBox = (index, checkedStatus, item) => {
    setSelectedHistory(checkedStatus ? item : null);
  };

  const handleOnArchive = (item) => {
    setOpenArchiveDialog(true);
  };

  useEffect(() => {
    setList(
      shipsList.map((res, index) => {
        return {
          ...res,
          // Sno: index + 1,
          isSelected: false,
        };
      }),
    );
  }, [shipsList]);

   useEffect(() => {
    if (list.length > 0) {
      if (selectedHistory) {
        const items = list.map((res) => {
          return {
            ...res,
            isSelected: res._id === selectedHistory._id,
          };
        });
        setList(items);
      } else {
        const items = list.map((res) => {
          return {
            ...res,
            isSelected: false,
          };
        });
        setList(items);
      }
    }
  }, [selectedHistory]);


  const handleGetShips = async (fromSearch = true) => {
    setIsLoading(true);
    source.cancel();
    source = CancelToken.source();
    const response = await appapi.get(
      `/fleet/archiveAllShip`,
      {
        pageNumber: payload.page,
        filter: payload.filter ? payload.filter : null,
        pageSize: payload.limit,
        status: payload.status,
        sortOrderField: payload.field === 'shipName' ? 'shipSortName' : payload.field,
        sortOrder: payload.sortOrder,
        companyId: user?.companyId,
      },
      { cancelToken: source.token },
    );
    if (response.ok) {
      const data = response.data;
      if (data.status === '7400') {
        let shipData = data?.response.response;
        shipData &&
          shipData?.map((item, index) => {
            item.Sno = payload.limit * (payload.page === 1 ? 0 : payload.page - 1) + index + 1;
            return item;
          });
        setShipsList(shipData);
        setPayload((prev) => ({ ...prev, totalLength: data?.response?.length, paginationPage: payload.page === 1 ? 0 : payload.page - 1 }));
        setIsLoading(false);
      } else {
        setShipsList([]);
        setPayload((prev) => ({ ...prev, totalLength: 0, limt: 10, paginationPage: 0, page: 1 }));
        setIsLoading(false);
      }
    } else {
      setShipsList([]);
      setPayload((prev) => ({ ...prev, totalLength: 0, limt: 10, paginationPage: 1, page: 1 }));
      // setIsLoading(false);
    }
  };

  useEffect(() => {
    handleGetShips();
    return () => {
      if (source) {
        source.cancel();
      }
    };
  }, [payload.page, payload.filter, payload.field, payload.sortOrder]);

  const handleExcelDownload = async (format) => {
    const response = await appapi.get(
      `/fleet/excelArchiveShip`,
      {
        filter: payload.filter ? payload.filter : null,
        role: payload.role,
        sortOrderField: payload.field === 'shipName' ? 'shipSortName' : payload.field === 'designation' ? 'sortDesignation' : payload.field,
        sortOrder: payload.sortOrder,
        format,
        companyId: user?.companyId,
      },
      { observe: 'response', responseType: 'blob' },
    );
    if (response.ok) {
      try {
        const url = window.URL.createObjectURL(response.data);
        const link = document.createElement('a');
        link.href = url;
        const ext = format === 'csv' ? 'csv' : 'xlsx';
        link.download = `ARCHIVESHIPS${new Date().getTime()}.${ext}`;
        link.click();
        window.URL.revokeObjectURL(url);
      } catch (error) {
        console.error('Error downloading:', error);
      }
    } else {
    }
  };

  const selectRow = (sitem, sindex) => {
    const users = shipsList.map((item, index) => {
      item.Sno = payload.limit * (payload.page === 1 ? 0 : payload.page - 1) + index + 1;
      item.selected = item._id === sitem._id;
      return item;
    });
    setSelectedData(sitem);
    setShipsList(users);
    setIsDrawerOpen(true);
  };

  return (
    <Dialog
      sx={sx}
      open={modelOpen}
    >
      <Stack
        flex={1}
        direction={'row'}
        className="m-[8px] rounded-[8px] bg-white"
      >
        <Stack flex={1}>
          <PageHeader
            handleFilterButton={payload.totalLength > 0 ? true : false}
            handleOnSearchEmit={(search) => {
              handleSearchEmit(search);
            }}
            onExport={(type) => {
              handleExcelDownload(type);
            }}
            columnPreference={payload.totalLength > 0 ? true : false}
          columns={customerManagementColumn}
          applyColumnPreference={(c) => setCustomerManagementColumn(c)}
            showExport={payload.totalLength > 0 ? true : false}
            isArchive={true}
            showArchive={true}
            disableArchive={selectedHistory ? false : true}
            onArchive={(item) => handleOnArchive(item)}
            onRefresh={() => {
              if (payload.page === 1) {
                handleGetShips();
              } else {
                setPayload((prevState) => ({ ...prevState, paginationPage: 0, page: 1 }));
              }
            }}
          >
            <Stack
              direction="row"
              flex={1}
            >
              {' '}
              <Stack flexGrow={1} />
              {/* <Button
                sx={{ color: theme.palette.primary.main }}
                className="fs-14 ff-Roboto fw-medium !mr-[20px]"
                onClick={() => {
                  setAddEditShipOpen(true);
                  // setType('add');
                  // setSelectedData(null);
                }}
                variant="text"
                // startIcon={<AddShip />}
              >
                <img
                  src={AddShip}
                  style={{ marginRight: '5px' }}
                />
                ADD SHIP
              </Button> */}
            </Stack>
          </PageHeader>
          <Stack
            flexGrow={1}
            className="relative flex-auto overflow-auto h-0"
          >
            <Datatable
              tableHeadBgColor={'rgb(243 244 247)'}
              columns={customerManagementColumn.filter((res) => res.activeColumn)}
              data={list || []}
              isLoading={isLoading}
              onClickRow={(item, index) => {
                selectRow(item, index);
              }}
              showCheckBox={true}
              onChangeCheckBox={handleOnChangeCheckBox}
              onChangeFilter={(filterValues) => {
                const sortValues = filterValues?.sort;
                let columnUpdate = customerManagementColumn;
                columnUpdate[filterValues?.id].filter[`selectValue`] = filterValues?.filter.selectValue;
                if (sortValues) {
                  columnUpdate = columnUpdate.map((res) => {
                    return {
                      ...res,
                      sortOrder: sortValues.field === res.accessor ? sortValues.order : null,
                    };
                  });
                }
                setCustomerManagementColumn(columnUpdate);
                if (sortValues) {
                  setPayload((prevState) => ({ ...prevState, limt: 10, paginationPage: 0, page: 1, field: sortValues.field, sortOrder: sortValues.order, role: filterValues?.filter.selectValue }));
                } else {
                  setPayload((prevState) => ({ ...prevState, limt: 10, paginationPage: 0, page: 1, role: filterValues?.filter.selectValue }));
                }
              }}
              sortChange={(sortValues) => {
                const columnUpdate = customerManagementColumn.map((res) => {
                  return {
                    ...res,
                    sortOrder: sortValues.field === res.accessor ? sortValues.order : null,
                  };
                });
                setCustomerManagementColumn([...columnUpdate]);
                setPayload((prevState) => ({ ...prevState, limt: 10, paginationPage: 0, page: 1, field: sortValues.field, sortOrder: sortValues.order }));
              }}
            />
          </Stack>

          <Stack
            sx={{ width: '100%' }}
            className="relative pl-[16px]   inputFormStyle"
            direction={'row'}
          >
            <Button
              sx={[
                dialogButtonCancel,
                {
                  color: theme.palette.primary.main,
                  fontSize: '14px',
                  '&:hover': {},
                },
              ]}
              style={{ width: '230px', height: '48px' }}
              onClick={() => {
                onModelHandleClose(reload);
              }}
            >
              {t('Close')}
            </Button>
            <Box className="flex  justify-end items-center h-[56px] w-[100%] p-[5px]">
              <TablePagination
                rowsPerPageOptions={[]}
                count={payload.totalLength ? payload.totalLength : 0}
                rowsPerPage={payload.limit ? payload.limit : 10}
                page={payload.paginationPage ? payload.paginationPage : 0}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
                ActionsComponent={TablePaginationActions}
              />
            </Box>
          </Stack>
        </Stack>
        <Stack>
          {isDrawerOpen && <FleetDetailsTabPanel
            ship={selectedData}
            isDrawerOpen={isDrawerOpen}
            toggleDrawer={() => {
              if (selectedData) {
                handleToggleDrawer();
              }
            }}
            openEditUser={() => {
              // setAddEditShipOpen(true);
              // setType('edit');
            }}
            init={() => handleGetShips()}
            isArchived={true}
          />}
          
        </Stack>
        {openAddEditShip && (
          <AddShipTabPanel
            partyInfo={companyDetails}
            user={selectedData}
            modelOpen={openAddEditShip}
            onModelHandleClose={(event) => {
              if (event) {
                setPayload((prev) => ({ ...prev, page: 1 }));
                handleGetShips();
                setAddEditShipOpen(false);
              }
              setAddEditShipOpen(false);
            }}
            init={() => handleGetShips()}
          />
        )}
        {openArchiveDialog && (
          <ConfirmArchiveDialog
            modelOpen={openArchiveDialog}
            onModelHandleClose={(event) => {
              if (event) {
                setOpenArchiveDialog(false);
                setOpenArchiveList(false);
                setPayload((prev) => ({ ...prev, page: 1 }));
                handleGetShips();
                setReload(false);
                setSelectedHistory(null)
              }
              setOpenArchiveDialog(false);
            }}
            data={selectedHistory}
            status={0}
            type={'fleet'}
          />
        )}
      </Stack>
    </Dialog>
  );
}
